import { render } from "./MainFooter.vue?vue&type=template&id=363fdb9e"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"

import "./MainFooter.vue?vue&type=style&index=0&id=363fdb9e&lang=scss"

import exportComponent from "/builds/mindthegapstudio/stpancras-backstage-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__